'use client';
import { Loading } from '@/shared/components/parts/Loading';
import { InputLoginInfoForm } from './InputLoginInfoForm';
import { useUserCreateStart } from './index.hook';

export const UserCreateStart: React.FC = () => {
  const { state, loading, sendVerificationCode } = useUserCreateStart();

  return (
    <>
      {state.pageStatus === 'INPUT' && (
        <InputLoginInfoForm
          state={state}
          loading={loading}
          sendVerificationCode={sendVerificationCode}
        />
      )}

      {(state.pageStatus === 'VALIDATE_PASSWORD' ||
        state.pageStatus === 'SEND_EMAIL') && <Loading />}
    </>
  );
};
